module.exports = __webpack_public_path__ + "assets/img/1.af5c9098.svg";